import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';


interface ItemData2 {
  name: string;
  age: string;
  address: string;
}

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit, OnDestroy {
  listOfData2: ItemData2[] = [];

  value?: string;
  date = null;
  
  onChange(result: Date): void {
    console.log('onChange: ', result);
  }
  constructor() {
    
  }
  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
  ngOnInit() {
    for (let i = 0; i < 100; i++) {
      this.listOfData2.push({
        name: `${i}`,
        age: 'Kalubhai',
        address: 'General'
      });
    }
    
  }

}
